import React from 'react';
import { createBrowserRouter } from 'react-router-dom';

import { ProtectedRoute } from './ProtectedRoute';
import { PATHS } from './paths';

import App from '@/app/App';
import { Leverage } from '@/pages/Leverage';
import { WalletConnect } from '@/pages/WalletConnect';
import { Borrow } from '@/pages/Borrow';
import { BorrowDetails } from '@/pages/BorrowDetails';
import { Pool } from '@/pages/Pool';
import { TermsAndConditions } from '@/pages/TermsAndConditions';
import { PersonalisedPoolSuccess } from '@/pages/PersonalisedPoolSuccess';
import { PersonalisedPool } from '@/pages/PersonalisedPool/PersonalisedPool';
import { OrderBook } from '@/pages/OrderBook';
import { Vaults } from '@/pages/Vaults';
import { ManageDetails } from '@/pages/ManageDetails';
import { DefaultFallback, PageNotFound } from '@/app/Errors';
import { Team } from '@/pages/Team';

const router = createBrowserRouter([
    {
        path: PATHS.HOME,
        element: <App />,
        errorElement: <DefaultFallback />,
        children: [
            { path: PATHS.HOME, element: <Leverage /> },
            {
                path: PATHS.BORROW,
                element: (
                    <ProtectedRoute>
                        <Borrow />
                    </ProtectedRoute>
                ),
            },
            {
                path: PATHS.BORROW_DETAILS,
                element: (
                    <ProtectedRoute>
                        <BorrowDetails />
                    </ProtectedRoute>
                ),
            },
            { path: PATHS.WALLET_CONNECT, element: <WalletConnect /> },
            {
                path: PATHS.POOL_DETAILS,
                element: (
                    <ProtectedRoute>
                        <Pool />
                    </ProtectedRoute>
                ),
            },
            { path: PATHS.TERMS_AND_CONDITIONS, element: <TermsAndConditions /> },
            {
                path: PATHS.POOL_PERSONALISED,
                element: (
                    <ProtectedRoute>
                        <PersonalisedPool />
                    </ProtectedRoute>
                ),
            },
            {
                path: PATHS.POOL_PERSONALISED_SUCCESS,
                element: (
                    <ProtectedRoute>
                        <PersonalisedPoolSuccess />
                    </ProtectedRoute>
                ),
            },
            { path: PATHS.ORDER_BOOK, element: <OrderBook /> },
            { path: PATHS.ORDER_BOOK_BORROW, element: <OrderBook /> },
            { path: PATHS.VAULTS, element: <Vaults /> },
            { path: PATHS.VAULTS_MANAGE, element: <Vaults /> },
            {
                path: PATHS.VAULTS_MANAGE_DETAILS,
                element: (
                    <ProtectedRoute>
                        <ManageDetails />
                    </ProtectedRoute>
                ),
            },
            { path: PATHS.TERMS_AND_CONDITIONS, element: <TermsAndConditions /> },
            { path: '*', element: <PageNotFound /> },
            {
                path: PATHS.TERMS_AND_CONDITIONS,
                element: <TermsAndConditions />,
            },
            {
                path: PATHS.TEAM,
                element: (
                    <ProtectedRoute>
                        <Team />
                    </ProtectedRoute>
                ),
            },
        ],
    },
]);

export default router;
